/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 import React, { useState, useEffect } from 'react';
import { APIGET, APIDEL, APIPATCH } from '../services/APIServices';
import demo from './demo.json';
import ThemeControls from "../Component/AllThemesControl";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '@mui/material/Switch';
import TablePagination from '@mui/material/TablePagination';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const SubTable = (props) => {
  const { useStyle } = ThemeControls;
  const classes = useStyle();
  const fieldColumn = props.fieldsData;
  const subresponse = props.subresponse;
  const setSubResponse = props.setSubResponse;
  const contextJson = props.contextJson;
  const apiContextObj = props.apiContextObj;
  let id = props.id;
  const [dataSource, setDataSource] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [resOpen, setResOpen] = React.useState(false);
  const [editOpen, seteditOpen] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const [index, setIndex] = React.useState(false);
  const [refresh, setRefresh] = React.useState(false);
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = React.useState(5);
  // const [value, setValue] = React.useState(); 

  const handleClickOpen = (index) => {
    setOpen(true);
    setIndex(index);
  };

  const handleClose = () => {
    setOpen(false);
    setResOpen(false)
  };

  const handleResClose = () => {
    seteditOpen(false);
  };
  function hendleResponse(res) {
    if(res.dataRecevied.statusCode="SUCCESS"){
      setErrorMsg('Successfully deleted')
      seteditOpen(true);
      setOpen(false);
      setRefresh(pre=>!pre)
      // setSubResponse(true);
    }
  }
  function hendleEditResponse(res) {
    if(res.dataRecevied.statusCode="SUCCESS"){
      setErrorMsg('Successfully Update Active Status')
      seteditOpen(true)
    }
  }

  async function deleteItem() {
    try {
      const response = await APIDEL(`${props.apiPath}/${dataSource[index].skey}`,{},contextJson,hendleResponse);
       
      if (response) {
        // Optionally, you can handle the success response here.
        return response;
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  useEffect(() => {
    async function fetchData(path) {

      try {
        const data = await APIGET(path);
        if (data && data.data) {
          setDataSource(data.data);
          // setFilteredData(data.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    }
      if(id){
      let path =apiContextObj.apiContext+apiContextObj.type+id
      fetchData(path);
      }else{
        let path =apiContextObj.apiContext+apiContextObj.type
        fetchData(path);
      }
  }, [apiContextObj.apiContext,subresponse, refresh]);

  // useEffect(() => {
  //   const startIndex = page * rowsPerPage;
  //   const endIndex = startIndex + rowsPerPage;
  //   if(filteredData){
  //     setDataSource(filteredData.slice(startIndex, endIndex))
  //   }
  //   },[filteredData, page, rowsPerPage])


  // const handlePageChange = (event, newPage) => {
  //   setPage(newPage);
  // };
  // const handleChangeRowsPerPage = (event) => {
   
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };


  function handelchange(e, i) {
    const updatedData = [...dataSource];
    const newDataItem = { ...updatedData[i] };
    newDataItem.activestatus = e.target.checked ? 1 : 0;;
    updatedData[i] = newDataItem;

    // Update the local state to reflect the change immediately
    setDataSource(updatedData);

    // Send a PATCH request to update the 'active' property in your API
    updateItem(newDataItem, i);
  }
// //console.log(dataSource)
// //console.log(id)
  async function updateItem(newDataItem, i) {
    try {
      const response = await APIPATCH(`${props.apiPath}/${dataSource[i].skey}`, newDataItem,contextJson,hendleEditResponse);
       
      if (response) {
        // Optionally, you can handle the success response here.
        return response;
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  function RenderRow(props) {
    const { index, fieldColumn } = props;
    console.log(fieldColumn)
    const rowData = dataSource[String(index)];
    const keys = fieldColumn.map((column) => column.dataIndex);

    function getOptionLabel(dataIndex, value) {
      const field = fieldColumn.find((item) => item.dataIndex === dataIndex);
      console.log(field)
      if (field && field.field_options !== null && Array.isArray(field.field_options)) {
        const option = field.field_options.find((option) => option.value == value);
        if (option) {
            return option.option_label;
        }
    }

      return value;
    }

    return (
      <tr key={index}>
        {keys.map((key, index) => (<td key={index}>{getOptionLabel(key,rowData[key])}</td>))}
        {apiContextObj.action&&<td>
          <span className='deleteBtn' onClick={() => handleClickOpen(index)}>Delete</span>
        </td>}
        {apiContextObj.action&&<td>
          <Switch
            className='switch'
            checked={rowData.activestatus===1?true:false}
            onChange={(e) => handelchange(e, index)}
          />
        </td>}
      </tr>
    );
  }

  return (
    <>
    <Snackbar className={classes.errorpopup} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={editOpen} autoHideDuration={3000} onClose={handleResClose}>
        <Alert onClose={handleResClose} severity="success" sx={{ width: '100%' }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog
        maxWidth='sm'
        open={open}
        onClose={handleClose}
      >
      <div>
      <DialogTitle>Are you sure you want to delete?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Warning: You cannot undo the action. The following will be deleted forever.
          </DialogContentText>
        </DialogContent>
        <Box
          sx={{
            flexDirection: 'column',
            m: 'auto',
            width: 'fit-content',
          }}
        >
          <Button sx={{ marginRight: '10px' }} variant="outlined" onClick={handleClose}>
            No
          </Button>
          <Button variant="outlined" onClick={deleteItem}>
            Yes
          </Button>
        </Box>
      </div>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
      <table className={classes.subtable}>
        <thead>
          <tr>
            {fieldColumn.map((column) => (<th key={column.key}>{String(column.title)}</th>))}
            {apiContextObj.action&&<th>Action</th>}
            {apiContextObj.action&&<th>Active Status</th>}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={apiContextObj.action?fieldColumn.length+ 2:fieldColumn.length}>Loading...</td>
            </tr>
          ):dataSource.length===0 ?(<td colSpan={apiContextObj.action?fieldColumn.length + 2:fieldColumn.length}>No Data</td>):(
            dataSource.map((_, index) => <RenderRow key={index} index={index} fieldColumn={fieldColumn} />)
          )}
        </tbody>
      </table>
      {/* <div className={classes.pagination}>
          <TablePagination
            component="div"
            labelRowsPerPage='Show row per page'
            count={filteredData.length}
            page={page}
            onPageChange={handlePageChange}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div> */}
    </>
  );
};

export default SubTable;
